export default __webpack_public_path__ + "static/what-to-expect-84159ffce615dae01aba544bfc8fb25f.png";